import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Vimeo from '@vimeo/player'
gsap.registerPlugin(ScrollTrigger)
const helpers = {
  smoothScrollTo: () => import('./../helpers/smooth-scroll-to'),
  updateSmoothScroll: () => import('./../helpers/smooth-scroll-update'),
  blockSmoothScroll: async () =>
    await import('./../helpers/block-smooth-scroll'),
}
export const homepage = () => {
  $('.contact-to').click(function () {
    helpers.smoothScrollTo().then((module) => {
      module.smoothScrollTo('#contattito')
    })
  })

  if ($(".type-container[data-type='best']").length > 0) {
    const divs = document.querySelectorAll(
      ".type-container[data-type='best'] .block-preview"
    )
    $(".type-container[data-type='best']").html('')
    const divsArray = Array.from(divs)
    for (let i = divsArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[divsArray[i], divsArray[j]] = [divsArray[j], divsArray[i]]
    }
    const container = document.querySelector(
      ".type-container[data-type='best']"
    )
    divsArray.forEach((div) => container.appendChild(div))
  }

  $('textarea').on('keyup', function () {
    this.style.height = 'auto'
    this.style.height = this.scrollHeight + 'px'
  })

  let criteria
  function setCriteria() {
    if (!criteria && $("input[name='criteria']").length > 0) {
      $.ajax({
        url: ajaxurl,
        method: 'POST',
        data: {
          action: 'functions',
          function: 'get_criteria',
          data: {},
        },
        success: function (response) {
          criteria = response
          $("input[name='criteria']").val(criteria)
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
          // console.log("Status: " + textStatus,"Error: " + errorThrown);
        },
      })
    }
  }
  setTimeout(function () {
    setCriteria()
  }, 3000)
  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
  }
  $.fn.serializeObject = function () {
    var obj = {}

    $.each(this.serializeArray(), function (i, o) {
      var n = o.name,
        v = o.value

      obj[n] =
        obj[n] === undefined
          ? v
          : $.isArray(obj[n])
          ? obj[n].concat(v)
          : [obj[n], v]
    })

    return obj
  }
  $('.form-send').submit(function (e) {
    e.preventDefault()
    let parent = $(this)
    $('.error').removeClass('error')
    let send = true
    $("input[type='text'],textarea,select", parent).each(function (index) {
      if (!$(this).val()) {
        $(this).addClass('error')
        send = false
      }
    })
    if (!$("input[name='pp']", parent).is(':checked')) {
      $("input[name='pp']", parent).addClass('error')
      send = false
    }
    if (!validateEmail($("input[name='email']", parent).val())) {
      $("input[name='email']", parent).addClass('error')
      send = false
    }

    if (send) {
      parent.addClass('loading')
      var formValues = parent.serializeObject()
      $.ajax({
        url: ajaxurl,
        method: 'POST',
        data: {
          action: 'functions',
          function: 'send_form',
          data: formValues,
        },
        success: function (response) {
          $('#contattito').addClass('showmessage')
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
          console.log(errorThrown)
        },
      })
    } else {
    }
  })

  $('header').addClass('show-header')
  var myVar = setInterval(function () {
    myTimer()
  }, 10000)
  myTimer()

  function myTimer() {
    jQuery.ajax({
      url: ajaxurl,
      method: 'POST',
      data: {
        action: 'functions',
        function: 'check_time',
        data: {},
      },
      success: function (response) {
        $('.update-hours').html(response)
      },
      error: function (XMLHttpRequest, textStatus, errorThrown) {
        consoel.log('Status: ' + textStatus, 'Error: ' + errorThrown)
      },
    })
  }

  setTimeout(function () {
    $('html').addClass('animate')
  }, 300)
  var flicktys = $('.main-carousel').flickity({
    cellAlign: 'left',
    pageDots: false,
    wrapAround: false,
    contain: true,
    draggable: false,
    watchCSS: true,
  })
  $('.contact-anchor').click(function () {
    helpers.smoothScrollTo().then((module) => {
      module.smoothScrollTo('#colophon')
    })
  })

  function setCookie(name, value, days) {
    var expires = ''
    if (days) {
      var date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expires = '; expires=' + date.toUTCString()
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/'
  }

  $('#switch').change(function () {
    $('html').toggleClass('dark-mode')
    if ($('html').hasClass('dark-mode')) setCookie('dark', 'true', 365)
    else setCookie('dark', '', 365)
  })

  //  $(".filter-button").click(function(){
  // var type = $(this).attr("data-type")+"/";
  // var url = $("html").attr("data-url");
  // if(type == "best/")
  //   type = "";
  // if(url.includes("/it/")) {
  //   window.location.href = $("html").attr("data-url")+type;
  // } else {
  //   window.location.href = $("html").attr("data-url")+"/"+type;
  // }

  // $(".filter-button,.type-container").removeClass("active");
  // $(this).addClass("active");
  // $(".type-container[data-type='"+$(this).attr("data-type")+"']").addClass("active");
  // flicktys.flickity('resize');

  // window.history.replaceState(window.history.state,"",$(this).attr("data-url"));

  // ScrollTrigger.refresh();
  // helpers.updateSmoothScroll().then(module => module.smoothScrollUpdate());
  // $(".type-container.active .video-p-c").each(function(){
  //   $(this).attr("data-vimeo",$(this).attr("data-vimeo-temp"));
  // });
  // start_video();

  //});

  var fullPlayers = []
  $('.smooth-scroll iframe').each(function (index) {
    fullPlayers.push(new Vimeo($(this)[0]))
    fullPlayers[index].getDuration().then(function (seconds) {
      fullPlayers[index]['duration'] = seconds
    })

    fullPlayers[index].on('ended', function (data) {
      $('.video-iframe').removeClass('playing')
      fullPlayers[index].setCurrentTime(0)
    })
    fullPlayers[index].on('timeupdate', function (data) {
      $('.current-time', $('.video-iframe')[index]).text(
        new Date(data.seconds * 1000).toISOString().slice(14, 19)
      )
      $('.bar-indicator', $('.video-iframe')[index]).css(
        'width',
        data.percent * 100 + '%'
      )
    })
  })

  $('.mouse-move').click(function () {
    var parent = $(this).closest('.video-iframe')
    var player = fullPlayers[$('.video-iframe').index(parent)]
    if (parent.hasClass('playing')) {
      player.pause()
    } else {
      $('.video-iframe').removeClass('playing')
      player.play()

      if ($('html').hasClass('touch')) {
        player.requestFullscreen(true)
        document.addEventListener('fullscreenchange', function () {
          if (document.fullscreenElement) {
          } else {
            player.pause()
            parent.removeClass('playing')
          }
        })
        document.addEventListener('webkitfullscreenchange', function () {
          if (document.webkitIsFullScreen) {
          } else {
            player.pause()
            parent.removeClass('playing')
          }
        })
      }
    }
    parent.toggleClass('playing')
  })

  $('.full-screen').click(function () {
    var parent = $(this).closest('.video-iframe')
    parent.toggleClass('full')
    $('html').toggleClass('full')
    if (parent.hasClass('full')) {
      $('.full-screen').text('Exit')
      helpers
        .blockSmoothScroll()
        .then((module) => module.blockSmoothScroll(true))
    } else {
      $('.full-screen').text('Full screen')
      helpers
        .blockSmoothScroll()
        .then((module) => module.blockSmoothScroll(false))
    }
  })

  $('.bar-controller').click(function (e) {
    var parent = $(this).closest('.video-iframe')
    var index = $('.video-iframe').index(parent)
    var player = fullPlayers[index]
    var leftClick = e.pageX - $(this).offset().left
    var width = $(this).width()
    var videoPercentage = (leftClick * 100) / width
    $('.current-time', $('.video-iframe')[index]).text('Loading')
    $('.bar-indicator', $('.video-iframe')[index]).css(
      'width',
      videoPercentage + '%'
    )
    player.setCurrentTime(
      parseFloat(fullPlayers[index]['duration']) * (videoPercentage / 100)
    )
  })

  $('.sound').click(function (e) {
    var parent = $(this).closest('.video-iframe')
    var index = $('.video-iframe').index(parent)
    var player = fullPlayers[index]
    $(this).toggleClass('audio-off')
    if ($(this).hasClass('audio-off')) {
      player.setVolume(0)
      $(this).text('Sound on')
    } else {
      player.setVolume(1)
      $(this).text('Sound off')
    }
  })

  let timeoutId

  document.onmousemove = function () {
    $('.video-iframe').removeClass('notMoving')
    clearTimeout(timeoutId)
    timeoutId = setTimeout(function () {
      $('.video-iframe').addClass('notMoving')
    }, 800)
  }

  $('.video-iframe').each(function (index) {
    customCursor(
      $('.mouse-follow', this)[0],
      $('.mouse-move', this)[0],
      $('.controls', this)[0],
      true,
      false,
      true
    )
  })

  function customCursor(
    cursor,
    container,
    controls,
    backToOriginalPosition,
    considerHorizontalScroll,
    smooth = true
  ) {
    var y_move
    ScrollTrigger.matchMedia({
      '(min-width: 768px) and (pointer: fine)': function () {
        container.addEventListener('mousemove', (event) => {
          if (smooth) y_move = event.pageY
          else y_move = event.clientY

          if (
            y_move <
            container.getBoundingClientRect().y +
              container.clientHeight -
              (cursor.clientHeight / 2 + 20)
          ) {
            gsap.to(cursor, {
              //opacity: 1,
              x: considerHorizontalScroll
                ? event.pageX -
                  container.getBoundingClientRect().x -
                  container.clientWidth / 2
                : event.pageX -
                  container.clientWidth / 2 -
                  container.getBoundingClientRect().x,
              y:
                y_move -
                container.getBoundingClientRect().y -
                container.clientHeight / 2,
            })
          } else {
            if (
              y_move >
              container.getBoundingClientRect().y +
                container.clientHeight -
                (cursor.clientHeight / 2 - 20)
            ) {
              mouseLeave()
            }
          }
        })

        controls.addEventListener('mousemove', (event) => {
          gsap.to(cursor, {
            opacity: 0,
            duration: 0.5,
          })
        })
        controls.addEventListener('mouseleave', (event) => {
          gsap.to(cursor, {
            opacity: 1,
            duration: 0.5,
          })
        })

        function mouseLeave() {
          gsap.to(cursor, {
            x: 0,
            y: 0,
            duration: 0.5,
          })
        }

        container.addEventListener('mouseleave', () => {
          mouseLeave()
        })
      },
    })
  }

  // $(".mouse-move").on('mousemove', function(e){
  //        var parentOffset = $(this).offset();
  //        $('.mouse-follow',this).css({
  //          opacity: 1,
  //          left:  e.pageX-30-parentOffset.left,
  //          top:   e.pageY-10-parentOffset.top
  //        });
  //   });
  //   $(".mouse-move").mouseleave(function() { $('.mouse-follow',this).css({opacity: 0}); });

  function getVideoThumbnails(videoid) {
    var token = '7b28e289d4ea116728828303a4a402a8'
    $.ajax({
      type: 'GET',
      url: 'https://api.vimeo.com/videos/' + videoid,
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }).done(function (data) {
      $("*[data-vimeo='" + videoid + "']").css(
        'background-image',
        'url(' + data.pictures.base_link + ')'
      )
      $("*[data-vimeo='" + videoid + "']").css('background-size', 'cover')
    })
  }

  var player_Array_inline = []
  var dataID
  var player = null
  var vimeoVideosInline = document.querySelectorAll('[data-vimeo]')
  async function initialize_video() {
    if (vimeoVideosInline) {
      for (const vimeoVideo of vimeoVideosInline) {
        dataID = vimeoVideo.getAttribute('data-vimeo')
        var vimeoID = $('.video-k', vimeoVideo).attr('id')
        getVideoThumbnails(dataID)
      }
    }
  }

  async function start_video() {
    await initialize_video()
    lazy_load_video()
  }
  function lazy_load_video() {
    if (vimeoVideosInline) {
      var i = 0
      for (const vimeoVideo of vimeoVideosInline) {
        if (
          $('.video-k', vimeoVideo).hasClass('entered') &&
          !$('.video-k', vimeoVideo).hasClass('done')
        ) {
          dataID = vimeoVideo.getAttribute('data-vimeo')
          $('.video-k', vimeoVideo).addClass('done')
          var vimeoID = $('.video-k', vimeoVideo).attr('id')
          getVideoThumbnails(dataID)
          var options = {
            id: dataID,
            width: 1920,
            muted: true,
            controls: false,
            background: true,
            dnt: true,
          }
          var vimeoVIDEO = new Vimeo(vimeoID, options)
          player_Array_inline.push({
            vimeoID: vimeoID,
            played: false,
            video: vimeoVIDEO,
            dnt: true,
          })
          i++
        }
      }
    }
    setTimeout(function () {
      lazy_load_video()
    }, 200)
  }
  start_video()
}
